'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_forms_FormLabel_FormLabel = require('../FormLabel/FormLabel.cjs.js');
require('../FormLabel/FormLabelRequiredText.cjs.js');
const hooks_useOverflow = require('../../../hooks/useOverflow.cjs.js');
const utils_uniqueId = require('../../../utils/uniqueId.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const field = "_field_c833z_1";
const helpTextWrapper = "_help-text-wrapper_c833z_6";
const helpText = "_help-text_c833z_6";
const helpTextInner = "_help-text-inner_c833z_21";
const helpTextToggle = "_help-text-toggle_c833z_32";
const error = "_error_c833z_48";
const styles = {
	field: field,
	helpTextWrapper: helpTextWrapper,
	helpText: helpText,
	helpTextInner: helpTextInner,
	helpTextToggle: helpTextToggle,
	error: error
};

const HelpText = ({ children, helpTextLineClamp }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOverflowing, setOverflowingNode] = hooks_useOverflow.useOverflow();
  const toggle = isOverflowing && React__default.default.createElement("button", { "aria-hidden": "true", className: styles.helpTextToggle, onClick: () => setIsOpen(!isOpen), type: "button", "data-zds": true }, isOpen ? "Less" : "More");
  const style = {
    WebkitLineClamp: isOpen ? void 0 : helpTextLineClamp
  };
  return React__default.default.createElement(
    "div",
    { className: styles.helpText, "data-zds": true },
    React__default.default.createElement(
      "div",
      { className: styles.helpTextInner, ref: (node) => setOverflowingNode(node), "data-zds": true, style },
      React__default.default.createElement("div", { "data-zds": true }, children)
    ),
    toggle
  );
};
const Field = ({ label, renderInput, error = void 0, inputId = void 0, isCompact = false, isDisabled = void 0, isRequired = void 0, helpTextLineClamp = 1, renderHelpText = void 0, renderLabel = void 0, requiredText = void 0 }) => {
  const [id] = React.useState(inputId || utils_uniqueId.uniqueId("Field-"));
  const describedById = `${id}-description`;
  const helpText = renderHelpText && renderHelpText();
  return React__default.default.createElement(
    "div",
    { className: styles.field, "data-zds": true },
    React__default.default.createElement("div", { "data-zds": true }, renderLabel ? renderLabel({
      htmlFor: id,
      isDisabled,
      isErrored: !!error,
      isRequired,
      label,
      requiredText
    }) : React__default.default.createElement(
      components_forms_FormLabel_FormLabel.FormLabel,
      { alignItems: "start", htmlFor: id, isDisabled, isErrored: !!error, isRequired, requiredText, size: isCompact ? "compact" : "small" },
      error && React__default.default.createElement(components_display_Icon_Icon.Icon, { color: "StatusErrorStronger", isBlock: true, name: "formXCircle", size: 18 }),
      React__default.default.createElement("span", { "data-zds": true }, label)
    )),
    React__default.default.createElement("div", { "data-zds": true }, renderInput({
      ariaDescribedBy: helpText || error ? describedById : void 0,
      id,
      isDisabled: !!isDisabled,
      isErrored: !!error,
      isRequired: !!isRequired
    })),
    React__default.default.createElement("div", { "aria-live": error ? "polite" : "off", className: styles.helpTextWrapper, "data-compact": isCompact, id: describedById, "data-zds": true }, (helpText || error) && React__default.default.createElement(
      HelpText,
      { helpTextLineClamp },
      error && React__default.default.createElement(
        "div",
        { className: styles.error },
        error,
        " "
      ),
      helpText
    ))
  );
};

exports.Field = Field;
//# sourceMappingURL=Field.cjs.js.map
